import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Router from 'router/Router';
import { usePageReloadOnFocus } from 'hooks/usePageReloadOnFocus';
import { Notifications } from 'components/complex';
import { theme } from 'muiTheme/theme';

import store from './store';

import './assets/fonts/fonts.css';

const App = () => {
  usePageReloadOnFocus();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Router />
          <Notifications />
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
